var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MaterialIcons from '@/components/material-icons.vue';
import HierarchyProjectNode from '@/components/hierarchy-project-node.vue';
var ProjectModule = namespace('project');
var HierarchyMonthNode = /** @class */ (function (_super) {
    __extends(HierarchyMonthNode, _super);
    function HierarchyMonthNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isExpanded = false;
        _this.loading = false;
        _this.scrollObserver = null;
        return _this;
    }
    Object.defineProperty(HierarchyMonthNode.prototype, "projects", {
        get: function () {
            return this.getProjects(this.year, this.month) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HierarchyMonthNode.prototype, "totalCount", {
        get: function () {
            var paginate = this.getHierarchyProjectsPaginate(this.year, this.month);
            return paginate ? paginate.total_count : this.count;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HierarchyMonthNode.prototype, "hasMore", {
        get: function () {
            return this.projects.length < this.totalCount;
        },
        enumerable: false,
        configurable: true
    });
    HierarchyMonthNode.prototype.toggleExpand = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isExpanded = !this.isExpanded;
                        if (!(this.isExpanded && this.projects.length === 0)) return [3 /*break*/, 4];
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.fetchHierarchyProjects({ year: this.year, month: this.month })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4:
                        if (this.isExpanded) {
                            this.$nextTick(function () { return _this.setupScrollObserver(); });
                        }
                        else {
                            this.disconnectScrollObserver();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HierarchyMonthNode.prototype.updated = function () {
        var _this = this;
        if (this.isExpanded) {
            this.$nextTick(function () { return _this.setupScrollObserver(); });
        }
    };
    HierarchyMonthNode.prototype.beforeDestroy = function () {
        this.disconnectScrollObserver();
    };
    HierarchyMonthNode.prototype.setupScrollObserver = function () {
        var _this = this;
        if (!this.hasMore || this.loading) {
            this.disconnectScrollObserver();
            return;
        }
        var scrollEl = this.$refs.projectListScroll;
        var sentinelEl = this.$refs.scrollSentinel;
        if (!scrollEl || !sentinelEl) {
            this.disconnectScrollObserver();
            return;
        }
        if (!this.scrollObserver) {
            this.scrollObserver = new IntersectionObserver(function (entries) {
                if (!entries[0].isIntersecting)
                    return;
                _this.loadMore();
            }, { root: scrollEl, rootMargin: '0px', threshold: 0 });
        }
        this.scrollObserver.disconnect();
        this.scrollObserver.observe(sentinelEl);
    };
    HierarchyMonthNode.prototype.disconnectScrollObserver = function () {
        if (this.scrollObserver) {
            this.scrollObserver.disconnect();
        }
    };
    HierarchyMonthNode.prototype.loadMore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading || !this.hasMore)
                            return [2 /*return*/];
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.fetchHierarchyProjects({
                                year: this.year,
                                month: this.month,
                                offset: this.projects.length
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4:
                        this.$nextTick(function () { return _this.setupScrollObserver(); });
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ required: true })
    ], HierarchyMonthNode.prototype, "year", void 0);
    __decorate([
        Prop({ required: true })
    ], HierarchyMonthNode.prototype, "month", void 0);
    __decorate([
        Prop({ required: true })
    ], HierarchyMonthNode.prototype, "count", void 0);
    __decorate([
        ProjectModule.Getter('hierarchyProjects')
    ], HierarchyMonthNode.prototype, "getProjects", void 0);
    __decorate([
        ProjectModule.Getter('hierarchyProjectsPaginate')
    ], HierarchyMonthNode.prototype, "getHierarchyProjectsPaginate", void 0);
    __decorate([
        ProjectModule.Action('fetchHierarchyProjects')
    ], HierarchyMonthNode.prototype, "fetchHierarchyProjects", void 0);
    HierarchyMonthNode = __decorate([
        Component({
            components: { MaterialIcons: MaterialIcons, HierarchyProjectNode: HierarchyProjectNode }
        })
    ], HierarchyMonthNode);
    return HierarchyMonthNode;
}(Vue));
export default HierarchyMonthNode;
